import React from 'react';

import AggregableMain from '../aggregable/AggregableMain';
import AggregableSummaryDataModel from '../aggregable/AggregableSummaryDataModel';

import ImportTradesColumnManager from './ImportTradesColumnManager';
import ImportTradesDataModel from './ImportTradesDataModel';
import ImportTradesSummaryView from './ImportTradesSummaryView';

export class ImportTradesMain extends AggregableMain {
  constructor(props) {
    super(props);

    this.summaryDataModel = new AggregableSummaryDataModel(this.counterparty.preferenceGroupName);

    this.dataModel = new ImportTradesDataModel(
      this.locale,
      this.counterparty,
      this.commandDataModel,
      this.summaryDataModel
    );

    this.columnManager = new ImportTradesColumnManager(
      this.session,
      this.counterparty
    );
    this.columnManager.settings.loadColumnSettings();
  }

  renderUsageSummaries() {
    return (
      <ImportTradesSummaryView
        dataModel={this.summaryDataModel}
        locale={this.locale}
      />
    );
  }
}
